import { TCustomersRevenues } from '../../api/APITypes';

export const MOCK_CUSTOMERS_REVENUES: TCustomersRevenues = [
  {
    customer_id: 21,
    customer_name: 'Jack Cook',
    total_revenue: 178127.03999999998,
    total_margin: 23861.440000000002,
    invoices_count: 8,
  },
  {
    customer_id: 7,
    customer_name: 'Jean Cook',
    total_revenue: 128442.13,
    total_margin: 18576.22,
    invoices_count: 7,
  },
  {
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    total_revenue: 243396.79,
    total_margin: 34743.850000000006,
    invoices_count: 11,
  },
  {
    customer_id: 36,
    customer_name: 'Martin Wu',
    total_revenue: 230354.91999999998,
    total_margin: 30853.130000000005,
    invoices_count: 11,
  },
  {
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    total_revenue: 225181.13,
    total_margin: 29246.22,
    invoices_count: 10,
  },
  {
    customer_id: 12,
    customer_name: 'Trisha Wu',
    total_revenue: 110618.29000000001,
    total_margin: 15502.970000000001,
    invoices_count: 5,
  },
  {
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    total_revenue: 188458.80000000002,
    total_margin: 23520.429999999997,
    invoices_count: 8,
  },
  {
    customer_id: 28,
    customer_name: 'Allan Cook',
    total_revenue: 161373.70000000004,
    total_margin: 24255.69,
    invoices_count: 7,
  },
  {
    customer_id: 1,
    customer_name: 'Magda Muijs',
    total_revenue: 240545.88000000003,
    total_margin: 30393.769999999997,
    invoices_count: 11,
  },
  {
    customer_id: 29,
    customer_name: 'John Cook',
    total_revenue: 205754.12000000002,
    total_margin: 25320.7,
    invoices_count: 10,
  },
  {
    customer_id: 39,
    customer_name: 'John Del Piero',
    total_revenue: 72093.48,
    total_margin: 9541.730000000001,
    invoices_count: 3,
  },
  {
    customer_id: 31,
    customer_name: 'Martijn Castex',
    total_revenue: 123673.44000000002,
    total_margin: 15113.630000000001,
    invoices_count: 9,
  },
  {
    customer_id: 32,
    customer_name: 'John Muijs',
    total_revenue: 131878.11,
    total_margin: 16844.149999999998,
    invoices_count: 7,
  },
  {
    customer_id: 30,
    customer_name: 'Jean Castex',
    total_revenue: 68581.13999999998,
    total_margin: 10775.25,
    invoices_count: 4,
  },
  {
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    total_revenue: 128350.51,
    total_margin: 15311.76,
    invoices_count: 8,
  },
  {
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    total_revenue: 164153.46,
    total_margin: 19246.739999999998,
    invoices_count: 7,
  },
  {
    customer_id: 16,
    customer_name: 'Greg Muijs',
    total_revenue: 6781.93,
    total_margin: 703.44,
    invoices_count: 2,
  },
  {
    customer_id: 38,
    customer_name: 'Mike Muijs',
    total_revenue: 35153.3,
    total_margin: 4313.950000000001,
    invoices_count: 4,
  },
  {
    customer_id: 37,
    customer_name: 'John Wu',
    total_revenue: 221539.63999999998,
    total_margin: 31802.45,
    invoices_count: 12,
  },
  {
    customer_id: 18,
    customer_name: 'Jack Wu',
    total_revenue: 118396.55,
    total_margin: 12748.68,
    invoices_count: 6,
  },
  {
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    total_revenue: 128773.77999999998,
    total_margin: 17107.210000000003,
    invoices_count: 8,
  },
  {
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    total_revenue: 155232.06,
    total_margin: 18005.46,
    invoices_count: 6,
  },
  {
    customer_id: 11,
    customer_name: 'Jean Martins',
    total_revenue: 124716.82999999999,
    total_margin: 16784.45,
    invoices_count: 7,
  },
  {
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    total_revenue: 74430.3,
    total_margin: 10538.51,
    invoices_count: 7,
  },
  {
    customer_id: 4,
    customer_name: 'Daniels Smith',
    total_revenue: 82722.70000000001,
    total_margin: 11710.19,
    invoices_count: 6,
  },
  {
    customer_id: 8,
    customer_name: 'Tim Jackson',
    total_revenue: 108471.63,
    total_margin: 14835.73,
    invoices_count: 5,
  },
  {
    customer_id: 22,
    customer_name: 'Martin Cook',
    total_revenue: 39269.630000000005,
    total_margin: 4534.65,
    invoices_count: 4,
  },
  {
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    total_revenue: 72295.24,
    total_margin: 8831.2,
    invoices_count: 5,
  },
  {
    customer_id: 17,
    customer_name: 'Saidi Martins',
    total_revenue: 154053.61000000002,
    total_margin: 20111.350000000002,
    invoices_count: 9,
  },
  {
    customer_id: 25,
    customer_name: 'Pablo Doe',
    total_revenue: 169886.04,
    total_margin: 20273.870000000003,
    invoices_count: 9,
  },
  {
    customer_id: 5,
    customer_name: 'Tim Smith',
    total_revenue: 52189.880000000005,
    total_margin: 5839.070000000001,
    invoices_count: 3,
  },
  {
    customer_id: 2,
    customer_name: 'Jack Muijs',
    total_revenue: 94462.43999999999,
    total_margin: 12726.190000000002,
    invoices_count: 10,
  },
  {
    customer_id: 26,
    customer_name: 'Magda Castex',
    total_revenue: 113254.51000000001,
    total_margin: 14478.76,
    invoices_count: 5,
  },
  {
    customer_id: 13,
    customer_name: 'Mike Jackson',
    total_revenue: 108442.43,
    total_margin: 15466.5,
    invoices_count: 4,
  },
  {
    customer_id: 9,
    customer_name: 'Daniels Martins',
    total_revenue: 71537.46,
    total_margin: 10430.260000000002,
    invoices_count: 6,
  },
  {
    customer_id: 34,
    customer_name: 'Mike Martins',
    total_revenue: 79827.26,
    total_margin: 10936.22,
    invoices_count: 3,
  },
  {
    customer_id: 14,
    customer_name: 'Magda Jackson',
    total_revenue: 41206.62000000001,
    total_margin: 5638.4,
    invoices_count: 2,
  },
];
